import { render, staticRenderFns } from "./error-view.vue?vue&type=template&id=0cfcac2e&scoped=true&lang=pug"
import script from "./error-view.js?vue&type=script&lang=js&external"
export * from "./error-view.js?vue&type=script&lang=js&external"
import style0 from "./error-view.vue?vue&type=style&index=0&id=0cfcac2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcac2e",
  null
  
)

export default component.exports